import type { PanelField } from "../panel/spec";
import { ErrorState } from "../shell/ui";
import { LightMotion } from "../components/LightMotion";
import { Select } from "../components/rumonai";

/**
 * How hard the models somebody else supplies think, as one choice under the models.
 *
 * The field's own words are what is drawn (its title, its answers, the line under it), the same as in a
 * form. Choosing is the whole act: it is saved as it is picked, and the box says it is saving until the
 * value is read back, so what it shows is what the Agent holds and not what was clicked.
 */
export function ModelLevel({ field, value, saving, error, onChoose, onRetry }: {
  field: PanelField;
  /** What the Agent holds now; "" is the answer that leaves it to the service. */
  value: string;
  /** The answer being saved, until it is read back. */
  saving: string | null;
  error?: unknown;
  onChoose: (value: string) => void;
  onRetry: () => void;
}) {
  const id = `model-level-${field.key}`;
  // Dressed as the form field it is, so it reads and looks the same as the settings below it.
  return <div className="connection-fields model-level"><div className="form"><div className="form-field form-field-short" data-field-key={field.key}>
    <label className="field-label micro" htmlFor={id}>{field.label}</label>
    <Select id={id} name={field.key} label={field.label} value={saving ?? value} disabled={saving !== null} aria-busy={saving !== null}
      aria-describedby={field.placeholder ? `${id}-help` : undefined}
      onValueChange={onChoose} items={(field.choices ?? []).map(choice => ({ value: choice, label: field.choice_labels?.[choice] ?? choice }))} />
    {saving !== null ? <span className="model-choice-state" role="status"><LightMotion compact state="working" />正在保存…</span> : null}
    {field.placeholder ? <p className="field-help micro" id={`${id}-help`}>{field.placeholder}</p> : null}
    {error ? <ErrorState error={error} onRetry={onRetry} /> : null}
  </div></div></div>;
}
